export { default as AboutWrapper } from './AboutWrapper';
